import { render } from "./multipleChoice.vue?vue&type=template&id=2cb8d51e&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"

import "./multipleChoice.vue?vue&type=style&index=0&id=2cb8d51e&lang=scss"
import "./multipleChoice.vue?vue&type=style&index=1&id=2cb8d51e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb8d51e"]])

export default __exports__